import React, { useState } from 'react';
import { IconSearch } from './Icons';

export default function SearchBar({ onSearch }) {
  const [value, setValue] = useState('');

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onSearch) onSearch(e.target.value);
  };

  return (
    <div className="search-wrapper" style={styles.wrapper}>
      <IconSearch size={16} color="#8A8D91" />
      <input
        style={styles.input}
        placeholder="Search products, brands…"
        value={value}
        onChange={handleChange}
      />
      {value && (
        <button
          style={styles.clearBtn}
          onClick={() => { setValue(''); if (onSearch) onSearch(''); }}
        >
          ✕
        </button>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#F0F2F5',
    borderRadius: 30,
    padding: '11px 16px',
    margin: '12px 16px',
    gap: 10,
    border: '1.5px solid #E4E6EA',
  },
  input: {
    flex: 1,
    background: 'none',
    border: 'none',
    outline: 'none',
    color: '#1C1E21',
    fontSize: 15,
    fontFamily: 'inherit',
    letterSpacing: '-0.1px',
  },
  clearBtn: {
    background: '#E4E6EA',
    border: 'none',
    borderRadius: 99,
    width: 20,
    height: 20,
    fontSize: 9,
    color: '#65676B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
};
